(function PortSearch($, Adzuki)
{
	"use strict";

	$(document).ready(function documentReady()
	{
		Adzuki.onload('Itineraries/portsOfCall', function _onload() {
			Adzuki.Typeahead('.ports-search', '/Itineraries/getPorts', function select(item) {
				document.location = Adzuki.base_uri + '/Itineraries/portSchedule/' + item.id;
			});
		});
	});

	// functions
}(jQuery, window.Adzuki || {}));